import { apiRequest } from './client';

/** Structured reports from chat sessions (SRS #35, #62–#68). */

const BASE = '/api/v1/reports';
const TOKEN_KEY = 'policyora_token';
function opts(extra: RequestInit = {}): RequestInit {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
}

export interface ReportFormat { key: string; label: string; audience: string; sections: string[] }
export interface ReportSection { heading: string; body: string; bullets: string[] }
export interface ReportContent {
  title: string; summary: string; sections: ReportSection[];
  gaps: { area: string; description: string; severity: 'high' | 'medium' | 'low' }[];
  recommendations: { priority: number; action: string; owner: string; rationale: string }[];
  evidence: { claim: string; source: string }[];
  confidence: 'high' | 'medium' | 'low'; caveats: string[]; sources: string[];
}
export interface GeneratedReport { id: number; format: string; title: string; session_id?: number | null; created_at: string; content: ReportContent }

export const listReportFormats = () => apiRequest<{ formats: ReportFormat[] }>(`${BASE}/formats`, opts());
export const generateReport = (session_id: number, format: string) =>
  apiRequest<GeneratedReport>(`${BASE}/generate`, opts({ method: 'POST', body: JSON.stringify({ session_id, format }) }));
export const listReports = () => apiRequest<{ reports: Omit<GeneratedReport, 'content'>[] }>(BASE, opts());
export const getReport = (id: number) => apiRequest<GeneratedReport>(`${BASE}/${id}`, opts());
export const deleteReport = (id: number) => apiRequest<void>(`${BASE}/${id}`, opts({ method: 'DELETE' }));

export async function downloadReport(id: number, kind: 'pdf' | 'html'): Promise<void> {
  const token = localStorage.getItem(TOKEN_KEY);
  const apiUrl = process.env.REACT_APP_API_BASE_URL ?? '';
  const res = await fetch(`${apiUrl}${BASE}/${id}/${kind}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const cd = res.headers.get('content-disposition') || '';
  const m = /filename="?([^"]+)"?/.exec(cd);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = m ? m[1] : `report.${kind}`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
